import { PreguntasTipoEnum } from "@shared/enums";
import { PreguntaImportador } from "../PreguntaImportador";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PreguntaCargaDTO } from "@DTOS";
import { PREGUNTA_PADRE } from "../constantesImportador";

export class PreguntaRankingImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.RANKING;
    }

    public procesar(datos: DatosPreguntaImportador[]): PreguntaCargaDTO[] {
        const preguntas = super.procesar(datos);
        const preguntaPadre = preguntas[PREGUNTA_PADRE];
        preguntaPadre.minimoItemsSeleccionados = preguntaPadre.minimo!;
        preguntaPadre.maximoItemsSeleccionados = preguntaPadre.maximo!;
        preguntaPadre.minimo = null;
        preguntaPadre.maximo = null;
        return preguntas;
    }
}
